<template>
  <div>
    <!-- Breadcrumb -->
    <div
      class="px-5 mt-[76px] w-full md:container md:px-0 md:mt-0 overflow-auto whitespace-nowrap breadcrumbs-container border-b md:border-0 border-manatee border-solid"
    >
      <Breadcrumbs class="" :navigation="navigation" />
    </div>
    <!-- ./Breadcrumb -->

    <BlogPage v-if="postListCount || routeQueue" />
    <EmptyBlogPage v-if="!postListCount && !routeQueue" />
  </div>
</template>
<script>
import Breadcrumbs from '~/components/merchant/Breadcrumbs.vue';

const BlogPage = () => import('~/components/blog/page/BlogPage.vue');
const EmptyBlogPage = () => import('~/components/blog/page/EmptyBlogPage.vue');

export default {
  name: 'Blog',
  components: {
    Breadcrumbs,
    BlogPage,
    EmptyBlogPage,
  },
  layout: 'blog',
  // eslint-disable-next-line consistent-return
  middleware({ error, route }) {
    try {
      // eslint-disable-next-line no-console
      const [, blogSlug] = route.path.split('/');

      if (blogSlug !== 'blog') {
        return error({ statusCode: 404, message: 'Page not found' });
      }
    } catch (e) {
      console.error('Error in middleware:', e);
      return error({ statusCode: 503, message: 'Internal Server Error' });
    }
  },
  async fetch() {
    await Promise.all([
      this.$store.dispatch('category/getCategories'),
      this.$store.dispatch('post/getPosts', {
        filter: {
          per_page: 11,
          page: this.$route?.query?.page,
          search: this.routeQueue,
        },
      }),
      this.$store.dispatch('post/getFeaturedPost'),
      this.$store.dispatch('page/getBlogPage', 'home'),
    ]);
  },
  head() {
    const script = [];

    if (process.env.DATA_ANALYTICS_BUCKET === '1') {
      const bucketSourcePrefix = process.env.NODE_ENV === 'production' ? '/_nuxt_blog_pages' : '';
      const bucketSource = `${bucketSourcePrefix}/da-bucket/dist/blog-pages/index.js`;

      const bucketScript = {
        src: bucketSource,
        body: true,
      };

      script.push(bucketScript);
    }

    return {
      script,
    };
  },
  computed: {
    navigation() {
      return [
        {
          href: '/',
          title: 'Home',
        },
        {
          href: '/blog/',
          title: 'Blog',
        },
      ];
    },
    postListCount() {
      return this.$store.state?.post?.list?.posts?.length || 0;
    },
    routeQueue() {
      return this.$route?.query?.q;
    },
  },
};
</script>
